<template>
  <div class="base">
    <inside-header title="订单" back-link-name="TeacherIndex" />
    <div class="order-menu">
      <div class="item">
        <div :class="status === 'Cancelling' ? 'active' : ''" @click="filterStatus('Cancelling')">
          取消中
        </div>
      </div>
      <div class="item">
        <div :class="status === 'Cancelled' ? 'active' : ''" @click="filterStatus('Cancelled')">
          已取消
        </div>
      </div>
      <div class="item">
        <div :class="status === 'Active' ? 'active' : ''" @click="filterStatus('Active')">
          进行中
        </div>
      </div>
      <div class="item">
        <div :class="status === 'Complete' ? 'active' : ''" @click="filterStatus('Complete')">
          已完成
        </div>
      </div>
      <div class="item">
        <div :class="status === 'all' ? 'active' : ''" @click="filterStatus('all')">
          全部
        </div>
      </div>
    </div>
    <div class="main">
      <div class="list">
        <van-empty v-if="list.length === 0 && !loading" description="没有订单数据哦~" />
        <div v-for="(order, index) in list" :key="index" class="item">
          <div class="header">
            <span v-if="order.status === 'Pending'" class="unpaid-status">待支付</span>
            <span v-if="order.status === 'Active'" class="progress-status">进行中</span>
            <span v-if="order.status === 'Cancelling'" class="cancel-status">取消中</span>
            <span v-if="order.status === 'Complete'" class="complete-status">已完成</span>
            <span v-if="order.status === 'Cancelled'" class="complete-status">已取消</span>
            <span class="timing">{{ order.create_time | timeFormat }}</span>
            <!-- <span class="time">00:30:00</span> -->
          </div>
          <div v-if="order.status === 'Cancelling'" class="title" @click="goOrderCanceling(order.ordernum)">
            {{ order.teaching_subject }}-{{ order.service_pack.title }}
          </div>
          <div v-else class="title" @click="goOrderDetails(order.ordernum)">
            {{ order.teaching_subject }}-{{ order.service_pack.title }}
          </div>
          <div class="complex">
            <a-row class="info">
              <a-col class="schedule" :span="18">
                <div class="cycle">
                  <span class="title">授课时间：</span>
                  <span class="content">{{ order.first_teach_date }} ~
                    {{ order.last_teach_date }}({{
                        order.teaching_time_str
                    }})</span>
                </div>
                <div class="day">
                  <span class="title">周期：</span>
                  <span class="content">{{ order.cycle }}周</span>
                </div>
                <div class="last-teach">
                  <span class="title">下次授课：</span>
                  <span class="content">{{ order.last_teaching_time }}</span>
                  <span v-if="order.last_teaching_str" class="week">（{{ order.last_teaching_str }}）</span>
                  <span v-else class="week">无</span>
                </div>
              </a-col>
              <a-col :span="6" class="amount">
                <span class="prefix">￥</span>
                <span class="money">{{ order.subtotal }}</span>
              </a-col>
            </a-row>
          </div>
          <!-- 支付 -->
          <div class="operation-area">
            <a-row>
              <a-col :span="3">
                <img class="student-header" src="@/assets/test-header.png" alt="">
              </a-col>
              <a-col :span="11">
                <div class="student-name">
                  {{ order.student.nick_name }}
                </div>
                <div class="grade">
                  {{ order.student.stage }}
                </div>
              </a-col>
              <a-col :span="10" align="right" class="show-details">
                <a-button @click="goOrderDetails(order.ordernum)">
                  查看详情
                </a-button>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="pagination">
        <van-pagination v-show="list.length > 0" v-model="paginate.current_page" :total-items="paginate.total"
          :show-page-size="3" force-ellipses @change="pageChange" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'Moment',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    page: {
      default: 1
    },
    status: {
      default: 'all'
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      order_status_type: [],
      pay_status_type: [],
      paginate: {},
      total: ''
    }
  },
  watch: {
    // url改变，重新加载数据
    $route() {
      this.loadData(this.page, this.status)
    },
    paginate(data) {
      // this.page = data.current_page
      this.total = data.total
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData(page, status) {
      this.loading = true
      this.$http({
        url: '/index/teacher/orderList',
        method: 'get',
        params: {
          page: page,
          status: status === 'all' ? '' : status
        }
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          const data = res.data
          this.list = data.list
          this.order_status_type = data.order_status_type
          this.pay_status_type = data.pay_status_type
          this.paginate = data.paginate
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    goTutor() {
      console.log(1)
    },
    pageChange(value) {
      this.paginate.current_page = value
      // this.$router.push({ name: 'TutorList', query: this.filterCondition })
    },
    goTeacherShow(teacherId) {
      this.$router.push({ name: 'RevealInfo', params: { id: teacherId } })
    },
    goOrderDetails(ordernum) {
      this.$router.push({
        name: 'TeacherOrderDetails',
        params: { ordernum: ordernum }
      })
    },
    filterStatus(target) {
      this.$router.push({
        name: 'TeacherOrder',
        query: { page: this.page, status: target }
      })
    },
    goOrderCancel(orderNum) {
      this.$router.push({
        name: 'TeacherOrderCancel',
        params: { ordernum: orderNum }
      })
    },
    goOrderCanceling(orderNum) {
      this.$router.push({
        name: 'TeacherOrderCanceling',
        params: { ordernum: orderNum }
      })
    },
    goPay(orderNum) {
      this.$router.push({ name: 'TutorPay', params: { id: orderNum } })
    }
  }
}
</script>
<style lang="stylus">
.base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
}

.top-title {
  width: 100%;
  height: 44px;
  line-height: 44px;

  padding: 0 10px;

  .title {
    margin-left: 10px;
  }
}

.order-menu {
  height: 40px;
  background-color: #ffffff;
  box-shadow: 1px 2px 5px 0px rgba(200, 200, 200, 0.24);

  .title {
    font-family: PingFang-SC-Medium;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 21px;
    letter-spacing: 0px;
    color: #333333;
    line-height: 40px;

    width: 45px;
    margin: auto;
  }

  .active {
    border-bottom: 2px solid $theme-color;
  }

  .item {
    width: 20%;
    float: left;
    text-align: center;

    .icon {
      font-size: 18px;
    }

    div {
      font-family: PingFang-SC-Medium;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 21px;
      letter-spacing: 0px;
      color: #333333;
      line-height: 40px;

      width: 45px;
      margin: auto;
    }
  }
}

.main {
  padding: 0 15px;

  .list {
    margin-top: 15px;

    .item {
      background-color: #ffffff;
      border-radius: 10px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
      padding: 15px;
      margin-bottom: 15px;

      .header {
        overflow: hidden;
        border-bottom: 1px solid #f1f1f1;
        padding-bottom: 15px;

        .unpaid-status, .progress-status {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          color: $theme-color;
          float: left;
        }

        .complete-status, .cancel-status {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #333333;
        }

        .timing {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          color: $theme-color;
          float: right;
        }

        .time {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          letter-spacing: 0px;
          color: #999999;
          float: right;
        }
      }

      .title {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        letter-spacing: 0px;
        color: #333333;
        font-weight: bold;
        margin-top: 10px;
      }

      .complex {
        height: 90px;

        .info {
          padding: 10px 0px;
          border-bottom:  1px solid #f1f1f1;

          .schedule {
            .day, .cycle, .last-teach {
              font-size: 12px;

              .title {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 21px;
                color: #999999;
              }

              .content {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #666666;
              }

              .week {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                font-weight: normal;
                letter-spacing: 0px;
                color: #ff5c00;
              }

            }
          }

          .amount {
            .prefix {
              font-family: PingFang-SC-Medium;
              font-size: 12px;
              line-height: 19px;
              color: #333333;
            }

            .money {
              font-family: PingFang-SC-Medium;
              font-size: 16px;
              font-weight: normal;
              letter-spacing: 0px;
              color: #333333;
            }
          }

        }
      }

      // 11
      .operation-area {
        padding: 20px 0px;
        img {
          width: 30px;
          height: 30px;
          background-color: #f3f3f3;
          border-radius: 50%;
        }

        .student-name {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          line-height: 18px;
          color: #333333;
          font-weight: bold;
        }

        .grade {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #999999;
        }

        .show-details {
          button {
            width: 86px;
            height: 31px;
            border-radius: 15px;
            border: solid 1px #ff5c00;
            color: $theme-color;
          }
        }
      }
    }
  }
}
</style>
